import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import { openDrawer } from 'main/store/common/reducer';

export const MainMenu = () => {
    const dispatch = useDispatch();

    const handleMenuClick = useCallback(() => {
        dispatch(openDrawer());
    }, [dispatch]);

    return (
        <Grid container direction="row">
            <IconButton size="large" color="inherit" onClick={handleMenuClick}>
                <MenuIcon />
            </IconButton>
            <Box py={1}>
                <Typography variant="caption">軟式少年野球チーム</Typography>
                <Typography variant="h6">相模ボンバーズ</Typography>
            </Box>
        </Grid>
    )
}
